export default __webpack_public_path__ + "static/media/near.cbad36fa.svg";